import { ApprovalsMaterializedApprovalsFlow } from 'generated/resources/graphql'

type EmailBlock = {
  key: string
  value: string
  type: 'string' | 'date'
  key_label: string
  resource_type: string
}

class MaterializedApprovalFlowUtils {
  static emailBlocks(
    flow: Pick<ApprovalsMaterializedApprovalsFlow, 'emailDetailBlocks'>
  ): EmailBlock[] {
    return (
      flow.emailDetailBlocks?.map((block) => {
        const jsonString = block?.replace(/=>/g, ':')
        return JSON.parse(String(jsonString))
      }) ?? []
    )
  }
}

export default MaterializedApprovalFlowUtils
